import styled from 'styled-components';

export const Container = styled.div`
  padding: 2rem 2rem 2rem 0;
`;

export const Title = styled.b`
  font-size: larger;
`;
